<template>
  <div>
    <div class="my-3 input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="filter">
          <i class="fa fa-search"></i>
        </span>
      </div>
      <input
        v-model.trim="filter"
        class="form-control"
        aria-describedby="filter"
        placeholder="filter by name"
      />
    </div>
    <loading-panel :loading="loading" class="m-auto">
      <div v-if="!pending.length && !owned.length && !accesses.length">No locations found.</div>
      <div v-if="pending.length > 0">
        <h4>Pending Locations (created by you)</h4>
        <div v-for="(location, ind) in pending" :key="`${ind}_ploc`">
          <button
            class="btn w-100 mb-2"
            :class="location === selected ? 'btn-primary' : 'btn-outline-primary'"
            @click="$emit('select', location)"
          >{{location.title}}</button>
        </div>
      </div>
      <div v-if="owned.length > 0" :class="pending.length ? 'mt-4' : ''">
        <h4>Company Locations</h4>
        <div v-for="(location, ind) in owned" :key="`${ind}_oloc`">
          <button
            class="btn w-100 mb-2"
            :class="location === selected ? 'btn-primary' : 'btn-outline-primary'"
            @click="$emit('select', location)"
          >{{location.title}}</button>
        </div>
      </div>
      <div v-if="accesses.length > 0" :class="owned.length || pending.length ? 'mt-4' : ''">
        <h4>Vendor Access</h4>
        <div v-for="(location, ind) in accesses" :key="`${ind}_oloc`">
          <button
            class="btn w-100 mb-2"
            :class="location === selected ? 'btn-primary' : 'btn-outline-primary'"
            @click="$emit('select', location)"
          >{{location.title}}</button>
        </div>
      </div>
    </loading-panel>
    <error-panel class="m-auto" :errors="errors"></error-panel>
  </div>
</template>

<script>
export default {
  name: "location-select",
  components: {},
  data: () => ({
    loading: true,
    errors: [],
    filteredLocations: [],
    selected: null,
    filter: ""
  }),
  methods: {
    matchesFilter(location) {
      return location.title.toLowerCase().includes(this.filter.toLowerCase());
    }
  },
  computed: {
    locations() {
      return this.$store.state.locations.list;
    },
    owned() {
      return this.$store.state.locations.list.filter(
        location => location.type === "owned" && this.matchesFilter(location)
      );
    },
    pending() {
      return this.$store.state.locations.list.filter(
        location => location.type === "pending" && this.matchesFilter(location)
      );
    },
    accesses() {
      return this.$store.state.locations.list.filter(
        location => location.type === "access" && this.matchesFilter(location)
      );
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch("loadLocations");
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  }
};
</script>